import React from 'react';
import Filter from '../Filter';
import FilterPresets from '../FilterPresets/FilterPresets';

const CombinedFilter = (props) => {

    let filter = (null);
    let filterPresets = (null);

    if (props.config.filters !== undefined && Array.isArray(props.config.filters)) {
        filter = <Filter 
                    filters={props.config.filters} 
                    clear={props.onClear} 
                    refresh={props.refresh} 
                    click={props.filterDropDownHandler} 
                    language={props.language}
                    searchText={props.searchText}
                    startDate={props.startDate}
                    endDate={props.endDate}
                    searchChangeHandler={props.searchChangeHandler}
                    dateChangeHandler={props.dateChangeHandler}
                    filterChangeHandler={props.filterChangeHandler}
                    filterSearch={props.filterSearch}
                    numberRanges={props.numberRanges}
                    dateSearch={props.dateSearch}
                    >
                </Filter>
    }

    if (props.filterPresets !== undefined && Array.isArray(props.filterPresets)) {
        filterPresets = <FilterPresets filterPresets={props.filterPresets} selectedPreset={props.config.selectedPreset} click={props.onPresetClick} language={props.language}></FilterPresets>
    }

    return (
        <div>
            {filter}
            {filterPresets}
        </div>
    );
}

export default CombinedFilter;